import React from "react";
import { motion } from "framer-motion";

const TrustedBySection: React.FC = () => {
  // Trusted partner salon logos
  const salonLogos = [
    { id: 1, name: "Salon 1", image: "/Trusted-Partner/Trusted-partner1.webp" },
    { id: 2, name: "Salon 2", image: "/Trusted-Partner/Trusted-partner2.webp" },
    { id: 3, name: "Salon 3", image: "/Trusted-Partner/Trusted-partner3.webp" },
    { id: 4, name: "Salon 4", image: "/Trusted-Partner/Trusted-partner4.webp" },
    { id: 5, name: "Salon 5", image: "/Trusted-Partner/Trusted-partner5.webp" },
    { id: 6, name: "Salon 6", image: "/Trusted-Partner/Trusted-partner6.webp" },
    { id: 7, name: "Salon 7", image: "/Trusted-Partner/Trusted-partner7.webp" },
    { id: 8, name: "Salon 8", image: "/Trusted-Partner/Trusted-partner8.webp" },
    { id: 9, name: "Salon 9", image: "/Trusted-Partner/Trusted-partner9.webp" },
    { id: 10, name: "Salon 10", image: "/Trusted-Partner/Trusted-partner10.webp" },
    { id: 11, name: "Salon 11", image: "/Trusted-Partner/Trusted-partner11.webp" }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-black mb-4">
            Trusted by Leading Salons
          </h2>
          <div className="w-24 h-1 bg-red-500 mx-auto"></div>
        </motion.div>

        {/* Scrolling Logos Container */}
        <div className="relative overflow-hidden">
          {/* Gradient Overlays */}
          <div className="absolute left-0 top-0 w-20 h-full bg-gradient-to-r from-white to-transparent z-10"></div>
          <div className="absolute right-0 top-0 w-20 h-full bg-gradient-to-l from-white to-transparent z-10"></div>
          
          {/* Scrolling Animation */}
          <motion.div
            className="flex space-x-8 items-center"
            animate={{
              x: [0, -100 * salonLogos.length],
            }}
            transition={{
              x: {
                repeat: Infinity,
                repeatType: "loop",
                duration: 20,
                ease: "linear",
              },
            }}
          >
            {/* First set of logos */}
            {salonLogos.map((salon) => (
              <motion.div
                key={salon.id}
                className="flex-shrink-0"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.2 }}
              >
                <div className="w-48 h-32 bg-white rounded-lg flex items-center justify-center border border-gray-300 shadow-lg overflow-hidden">
                  <img
                    src={salon.image}
                    alt={salon.name}
                    className="w-full h-full object-contain p-3"
                  />
                </div>
              </motion.div>
            ))}
            
            {/* Duplicate set for seamless loop */}
            {salonLogos.map((salon) => (
              <motion.div
                key={`duplicate-${salon.id}`}
                className="flex-shrink-0"
                whileHover={{ scale: 1.05 }}
                transition={{ duration: 0.2 }}
              >
                <div className="w-48 h-32 bg-white rounded-lg flex items-center justify-center border border-gray-300 shadow-lg overflow-hidden">
                  <img
                    src={salon.image}
                    alt={salon.name}
                    className="w-full h-full object-contain p-3"
                  />
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>

        {/* Stats Section */}
        {/* <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.3 }}
          viewport={{ once: true }}
          className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 text-center"
        >
          <div className="space-y-2">
            <div className="text-3xl md:text-4xl font-bold text-red-500">1000+</div>
            <div className="text-white text-lg">Salons Trust Us</div>
          </div>
          <div className="space-y-2">
            <div className="text-3xl md:text-4xl font-bold text-red-500">50+</div>
            <div className="text-white text-lg">Cities Across India</div>
          </div>
          <div className="space-y-2">
            <div className="text-3xl md:text-4xl font-bold text-red-500">4.9★</div>
            <div className="text-white text-lg">Average Rating</div>
          </div>
        </motion.div> */}
      </div>
    </section>
  );
};

export default TrustedBySection;
